// extracted by mini-css-extract-plugin
export default {"iconWrap":"QuestionBankList_iconWrap__x9ZTr","multiSelectMenu":"QuestionBankList_multiSelectMenu__jw4de","iconClose":"QuestionBankList_iconClose__aRXoK"};